/** Canonical width for KG table node cards — kept in sync with ELK NODE_WIDTH. */
export const KG_TABLE_NODE_WIDTH_PX = 180;

/** Max width for horizontal pill nodes (metric, artifact) — same as table for layout sync. */
export const KG_NODE_PILL_MAX_WIDTH_PX = KG_TABLE_NODE_WIDTH_PX;

/** Metric pill node — Figma node 2124-9876 (180×60). */
export const KG_METRIC_NODE_HEIGHT_PX = 60;

/** Tight gap between type label and entity name on KG pills (Figma: 2px). */
export const KG_NODE_LABEL_TEXT_GAP_PX = 2;

/** Report card width (Figma). */
export const KG_REPORT_NODE_WIDTH_PX = 160;

/**
 * Report card height without BI footer (16px pad ×2 + 44px icon + 12px gap + 18px label).
 * Keeps ELK layout aligned with the rendered card so edges meet the node center.
 */
export const KG_REPORT_NODE_HEIGHT_PX = 106;

/** Report card height when the pink BI source footer is shown. */
export const KG_REPORT_NODE_HEIGHT_WITH_FOOTER_PX = 141;

/** Data story card width (Figma). */
export const KG_DATA_STORY_NODE_WIDTH_PX = 130;

/** Data model isometric cube hex (Figma node 2749-280836: 112×124.42). */
export const KG_DATA_MODEL_NODE_WIDTH_PX = 112;
export const KG_DATA_MODEL_NODE_HEIGHT_PX = 124;

/** Text container width inside the data-model hexagon. */
export const KG_DATA_MODEL_TEXT_MAX_WIDTH_PX = 72;

/** Icon top offset inside cube (Figma group 2749:280839: y=15). */
export const KG_DATA_MODEL_ICON_TOP_PX = 15;

/** Canonical height for KG canvas nodes — kept in sync with ELK NODE_HEIGHT. */
export const KG_NODE_HEIGHT_PX = 140;

/** Fixed square size for KG data source nodes (Figma: 120×120). */
export const KG_SQUARE_NODE_SIZE_PX = 120;

/** Ontology circle node — Figma node 2124-9927 (112×112). */
export const KG_ONTOLOGY_NODE_SIZE_PX = 112;

/** Vertical gap between logo row and subtitle on data source cards (Figma: 2px). */
export const KG_DATA_SOURCE_TEXT_STACK_GAP_PX = 2;

/**
 * Single field row height on the canvas table card (8px padding × 2 + 16px line + border).
 * Keep in sync with `KgTableNodeCard` row styles (`semanticSpacing.squish.sm`).
 */
export const KG_TABLE_FIELD_ROW_HEIGHT_PX = 33;

/** Footer row for "+ N more" (8px padding × 2 + 14px overline-4 line). */
export const KG_TABLE_MORE_FOOTER_HEIGHT_PX = 30;

/** Rows visible in an expanded table card before the field list scrolls internally. */
export const KG_TABLE_EXPANDED_MAX_VISIBLE_ROWS = 4;

/** Cap on the expanded field list — beyond this it scrolls (scrollbar hidden). */
export const KG_TABLE_EXPANDED_FIELDS_MAX_HEIGHT_PX =
  KG_TABLE_EXPANDED_MAX_VISIBLE_ROWS * KG_TABLE_FIELD_ROW_HEIGHT_PX;
